import { Component, Input, OnInit } from "@angular/core";
import { UserInfoService } from "./../services/user-info.service";
import { IUser } from "../models/user.model";
import {
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { Subscription } from "rxjs";
import countries from "../../assets/data/countries.json";
import { ZpDataService } from "./../services/zp-data.service";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { CustomValidators } from "../custom-validators";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "../services/notification.service";
import { ZPNotification } from "../models/zpnotification";
import { DeviceDetectorService } from "ngx-device-detector";
import { ThemeService } from "../theme/theme-service.service";
import { Location } from "@angular/common";
import { PreviousUrlService } from "../services/previous-url.service";

@Component({
  selector: "app-account-settings",
  templateUrl: "./account-settings.component.html",
  styleUrls: ["./account-settings.component.scss"],
})
export class AccountSettingsComponent implements OnInit {
  @Input() firstPara = "Are you sure you want to delete you Zenplans account?";
  public deviceInfo = null;
  public statusMobileMenu: boolean;
  public chosenTab: string;
  public aboutMeFormGroup: FormGroup = new FormGroup({});
  public paymentFormGroup: FormGroup = new FormGroup({});
  public passwordFormGroup: FormGroup = new FormGroup({});
  public antiPhishingCodeFormGroup: FormGroup = new FormGroup({});
  public planUpdateFormGroup: FormGroup = new FormGroup({});
  public contactReferencesFormGroup: FormGroup = new FormGroup({});
  public itemOwnersFormGroup: FormGroup = new FormGroup({});
  public securityFormGroup: FormGroup = new FormGroup({});
  public editFormGroup: FormGroup = new FormGroup({});
  public subscription: Subscription;
  public subscription2: Subscription;
  public subscription3: Subscription;
  public subscription4: Promise<void>;
  public myUser: IUser;
  public myCountries = countries;
  public dataIsLoaded: boolean = false;
  public submitted = false;
  public mySharedPlans: {}[];
  public hasPlan: any;
  public showSideNav: string;
  public id: any;
  public section;
  public updateIsCheked: boolean;
  public reminderIsCheked: boolean;
  public message: string;
  public user = { clientId: "" };
  public refCode: any;
  public dataSponsor: any;
  public currentFile: any;
  public logoIsLoaded: boolean;
  public avatarUrl: any;
  public professionalProfession = [
    "Accountant",
    "IFA",
    "Solicitor",
    "Estate Planner",
  ];
  public statusPassword;
  public capsOn;
  public statusOldPassword;
  public planUpdates;
  public opt;
  public showModal = false;
  public isInvalid: boolean;
  public isAvatar: boolean;
  public hideBrokenImage: boolean = false;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public invalid: any;
  public country: any;
  public ownerFirstName: string;
  public ownerLastName: string;
  public showDialog = false;
  public itemToDeleteId;
  public itemNameforDialog;
  public displayOwnerForm: boolean;
  public jointOwnersList: IJointOwner[] = [];
  public currentOwner: IJointOwner = {
    first: " ",
    last: " ",
    relationship: " ",
  };
  public editCurrentOwner: boolean;
  public selectedOwner;
  public previousLink: string;
  public hideBackBtn: boolean;
  public ownerArrayWithItems: any = [];
  public itemCantBeDeleted: string;
  oldOwner: { first: string; last: string; relationship: any; };

  constructor(
    private userInfoService: UserInfoService,
    public zenplansDataService: ZpDataService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
    public themeService: ThemeService,
    private deviceService: DeviceDetectorService,
    private location: Location,
    private previousUrl: PreviousUrlService
  ) {
    // this.epicFunction();
  }

  async ngOnInit() {
    this.previousLink = this.previousUrl.getPreviousUrl();
    console.log(this.previousLink);
    if (
      this.previousLink == "/bank-account_joint-owners" ||
      this.previousLink == "/dynamicformdataentry/bank-account_joint-owners" ||
      this.previousLink.includes('/dynamicedit/bank-account-edit/')
    ) {
      this.hideBackBtn = false;
    } else {
      this.hideBackBtn = true;
    }
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    await this.getMyUser();
    this.mySharedPlans = await this.zenplansDataService.getSharedPlans(
      this.myUser
    );
    this.subscription = this.userInfoService.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
      console.log(this.myUser);
      this.ownerFirstName = this.myUser.firstName;
      this.ownerLastName = this.myUser.lastName;
      if (this.myUser.userType == "professional") {
        this.showSideNav = "professional";
      } else if (this.myUser.userType == "admin") {
        this.showSideNav = "admin";
      } else if (this.myUser.userType == "planHolder") {
        this.showSideNav = "regular";
      } else {
        this.showSideNav = "regular";
      }
      if (this.myUser && this.myUser.jointOwners) {
        this.jointOwnersList = this.myUser.jointOwners;
      }
      // this.section = this.activatedRoute.snapshot.paramMap.get('section')
      // this.openTab(this.section)
      if (this.jointOwnersList.length === 0) {
        console.log(this.jointOwnersList)
        let defaultUserToSave = {
          first: this.myUser.firstName,
          last: this.myUser.lastName,
          relationship: this.myUser.relationship,
          default: true
        }
        this.jointOwnersList.push(defaultUserToSave)
        console.log(this.jointOwnersList)
      }
    });

    this.subscription2 = this.sideNavBarVisibilityService
      .getMessage()
      .subscribe(async (visibility) => {
        let myUser = this.zenplansDataService.getItemUser(this.id, "users");
        this.hasPlan = await this.zenplansDataService.getPlan(myUser["Id"]);
        console.log('getPlan(), -', this.hasPlan)
        if (this.hasPlan) {
          this.showSideNav = "bottom";
        } else if (
          !this.hasPlan &&
          this.mySharedPlans &&
          this.mySharedPlans.length > 0
        ) {
          this.showSideNav = "top";
        }
      });

    this.subscription4 = this.zenplansDataService
      .getUser()
      .then(async (user) => {
        this.user = user;
        this.refCode = user.refCode;
        await this.zenplansDataService.setRefCode(this.refCode);
        this.dataSponsor = await this.zenplansDataService.retrieveValidRefCode(
          this.refCode
        );
      });

    this.updateScreen();
    this.antiPhishingCodeFormGroup.addControl(
      "Id",
      new FormControl(this.myUser.Id)
    );
    this.antiPhishingCodeFormGroup.addControl(
      "createAntiPhishingCode",
      new FormControl(
        this.myUser.createAntiPhishingCode
          ? this.myUser.createAntiPhishingCode
          : ""
      )
    );
    // Professional Manager
    if (this.myUser && this.myUser.userType == "professionalManager") {
      this.aboutMeFormGroup.addControl(
        "professionalAddress",
        new FormControl(this.myUser.professionalAddress, Validators.required)
      );
      this.securityFormGroup.addControl(
        "professionalProfession",
        new FormControl(
          this.myUser.professionalProfession
            ? this.myUser.professionalProfession
            : ""
        )
      );
    }

    // Professional Manager || Professional
    this.aboutMeFormGroup.addControl("Id", new FormControl(this.myUser.Id));
    if (
      (this.myUser && this.myUser.userType == "professional") ||
      (this.myUser && this.myUser.userType == "professionalManager")
    ) {
      this.aboutMeFormGroup.addControl(
        "company",
        new FormControl(this.myUser.company, Validators.required)
      );
    }

    // Different than Profeesional && Professional Manager
    if (
      (this.myUser && this.myUser.userType != "professional") ||
      (this.myUser && this.myUser.userType != "professionalManager")
    ) {
      this.aboutMeFormGroup.addControl(
        "phoneNumber",
        new FormControl(this.myUser.phoneNumber, Validators.required)
      );
      this.aboutMeFormGroup.addControl(
        "dateOfBirth",
        new FormControl(this.myUser.dateOfBirth)
      );
      this.aboutMeFormGroup.addControl(
        "country",
        new FormControl(
          this.myUser.country ? this.myUser.country : "",
          Validators.required
        )
      );
      this.planUpdateFormGroup.addControl(
        "planUpdateReminder",
        new FormControl(
          this.myUser.planUpdateReminder ? this.myUser.planUpdateReminder : ""
        )
      );
      this.contactReferencesFormGroup.addControl(
        "sendPlanUpdateReminders",
        new FormControl(
          this.myUser.sendPlanUpdateReminders
            ? this.myUser.sendPlanUpdateReminders
            : false
        )
      );
    }

    // Different than Professional
    if (this.myUser && this.myUser.userType != "professional") {
      this.aboutMeFormGroup.addControl(
        "postCode",
        new FormControl(this.myUser.postCode, Validators.required)
      );
      this.paymentFormGroup.addControl("Id", new FormControl(this.myUser.Id));
      this.paymentFormGroup.addControl(
        "ccHolder",
        new FormControl(
          this.myUser.ccHolder ? this.myUser.ccHolder : "",
          Validators.required
        )
      );
      this.paymentFormGroup.addControl(
        "ccNumber",
        new FormControl(
          this.myUser.ccNumber ? this.myUser.ccNumber : "",
          Validators.required
        )
      );
      this.paymentFormGroup.addControl(
        "ccExpire",
        new FormControl(
          this.myUser.ccExpire ? this.myUser.ccExpire : "",
          Validators.required
        )
      );
    }

    this.aboutMeFormGroup.addControl(
      "lastName",
      new FormControl(this.myUser.lastName, Validators.required)
    );
    this.aboutMeFormGroup.addControl(
      "firstName",
      new FormControl(this.myUser.firstName, Validators.required)
    );
    this.passwordFormGroup.addControl("Id", new FormControl(this.myUser.Id));
    this.passwordFormGroup.addControl(
      "password",
      new FormControl("", [Validators.required, Validators.minLength(6)])
    );
    this.passwordFormGroup.addControl(
      "oldPassword",
      new FormControl("", Validators.required)
    );
    this.securityFormGroup.addControl(
      "mfaAlways",
      new FormControl(this.myUser.mfaAlways ? this.myUser.mfaAlways : "")
    );
    this.securityFormGroup.addControl(
      "mfaVia",
      new FormControl(this.myUser.mfaVia ? this.myUser.mfaVia : "")
    );
    this.planUpdateFormGroup.addControl("Id", new FormControl(this.myUser.Id));
    this.contactReferencesFormGroup.addControl(
      "Id",
      new FormControl(this.myUser.Id)
    );
    this.contactReferencesFormGroup.addControl(
      "offersAuthorization",
      new FormControl(
        this.myUser.offersAuthorization
          ? this.myUser.offersAuthorization
          : false
      )
    );
    this.itemOwnersFormGroup.addControl(
      "first",
      new FormControl(this.currentOwner.first ? this.currentOwner.first : false)
    );
    this.itemOwnersFormGroup.addControl(
      "last",
      new FormControl(this.currentOwner.last ? this.currentOwner.last : false)
    );
    this.itemOwnersFormGroup.addControl(
      "relationship",
      new FormControl(this.currentOwner.relationship ? this.currentOwner.relationship : false)
    );

    this.dataIsLoaded = true;
    let self = this;
    window.setTimeout(function () {
      self.subscription3 = self.activatedRoute.url.subscribe((url) => {
        self.section = self.activatedRoute.snapshot.paramMap.get("section");
        self.openTab(self.section);
      });
    });
  }

  backToPlan() {
    this.location.back();
  }

  add() {
    this.displayOwnerForm = true;
    console.log(this.currentOwner);
    if (this.currentOwner !== null) {
      this.currentOwner.first = " ";
      this.currentOwner.last = " ";
      this.currentOwner.relationship = " ";
      console.log('currentOwner - ', this.currentOwner);
    }
    // this.itemOwnersFormGroup.reset();
  }

  back() {
    this.displayOwnerForm = false;
  }

  async addNewOwner() {
    this.itemOwnersFormGroup.value.first = this.itemOwnersFormGroup.value.first.trim();
    this.itemOwnersFormGroup.value.last = this.itemOwnersFormGroup.value.last.trim();
    this.itemOwnersFormGroup.value.relationship = this.itemOwnersFormGroup.value.relationship.trim();
    console.log('itemOwnersFormGroup.value - ', this.itemOwnersFormGroup.value);
    let formValue = this.itemOwnersFormGroup.value;
    let formValueArray = Object.values(formValue);
    console.log('formValueArray - ', formValueArray);
    for (let i = 0; i < formValueArray.length; i++) {
      let element = formValueArray[i];
      if (element == "" || element == " ") {
        console.log("Empty value.");
        this.notificationService.changeMessage(
          new ZPNotification(
            "Error.",
            undefined,
            undefined,
            "All the fields have to be filled."
          )
        );
        window.scrollTo(0, 0);
        return false;
      }
    }
    this.jointOwnersList.push(this.itemOwnersFormGroup.value);
    console.log('jointOwnerList - ', this.jointOwnersList);
    this.displayOwnerForm = false;
    const userToSave = {
      Id: this.myUser.Id,
      lastUpdate: new Date(),
      lastUpdateBy: this.myUser.Id,
      jointOwners: this.jointOwnersList,
    };
    await this.zenplansDataService.updateUser(userToSave);
    this.ngOnInit();
  }

  async editOwner(idx) {
    this.currentOwner = this.jointOwnersList[idx];
    this.oldOwner = { ...this.currentOwner };
    this.editCurrentOwner = true;
    if (this.selectedOwner == idx) {
      this.selectedOwner = null;
    } else {
      this.selectedOwner = idx;
    }
  }

  backFromEditOwner() {
    this.editCurrentOwner = false;
    this.selectedOwner = null;
  }

  async saveOwner(owner, idx) {
    this.currentOwner = this.jointOwnersList[idx];
    this.currentOwner.first = this.itemOwnersFormGroup.value["first"];
    this.currentOwner.last = this.itemOwnersFormGroup.value["last"];
    this.currentOwner.relationship = this.itemOwnersFormGroup.value["relationship"];
    this.ownerArrayWithItems = this.zenplansDataService.updateItemsOwnerName(this.hasPlan, this.currentOwner, this.oldOwner)
    if (this.ownerArrayWithItems.length) {
      console.log('this.ownerArrayWithItems - ', this.ownerArrayWithItems)
    }
    this.editCurrentOwner = false;
    let userToSave = {
      Id: this.myUser.Id,
      lastUpdate: new Date(),
      lastUpdateBy: this.myUser.Id,
      jointOwners: this.jointOwnersList,
    };
    await this.zenplansDataService.updateUser(userToSave);
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  async deleteOwner(idx, owner) {
    this.ownerArrayWithItems = this.zenplansDataService.findItemsOwnedByOwner(this.hasPlan, owner);
    if (this.ownerArrayWithItems.length) {
      console.log('can\'t be deleted')
      this.itemCantBeDeleted = this.ownerArrayWithItems.join(' ,');
      this.notificationService.changeMessage(
        new ZPNotification(
          'Request Accepted.',
          undefined,
          undefined,
          `This owner can't be deleted because he still is listed as owning the following item(s): ${this.itemCantBeDeleted} in the plan.`
        )
      );
    } else {
      console.log('deleted')
      this.myUser.jointOwners = this.jointOwnersList.splice(idx, 1);
      const userToSave = {
        Id: this.myUser.Id,
        lastUpdate: new Date(),
        lastUpdateBy: this.myUser.Id,
        jointOwners: this.jointOwnersList,
      };
      await this.zenplansDataService.updateUser(userToSave);
      this.ngOnInit();
    }
  }

  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
  }

  get device(): any {
    return this.deviceService.getDeviceInfo();
  }

  get isMobile(): boolean {
    return this.deviceService.isMobile();
  }

  get isTablet(): boolean {
    return this.deviceService.isTablet();
  }

  get isDesktop(): boolean {
    return this.deviceService.isDesktop();
  }

  async updateScreen() {
    this.avatarUrl = await this.zenplansDataService.getAvatar();
  }

  hideErrorImage() {
    setTimeout(() => {
      this.hideBrokenImage = true;
    }, 500);
  }

  async getMyUser() {
    if (!this.myUser) {
      await this.zenplansDataService.getUser();
    }
  }

  openTab(tabName) {
    this.dataIsLoaded = true;
    //this.dataIsLoaded = false;
    this.chosenTab = tabName;
    let i: any, tabcontent: any;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    document.getElementById(tabName).style.display = "flex";
    if (this.statusMobileMenu) {
      this.statusMobileMenu = false;
    }
    switch (tabName) {
      case "aboutMe":
        this.aboutMeFormGroup = new FormGroup({});

        this.aboutMeFormGroup.addControl("Id", new FormControl(this.myUser.Id));

        // Professional || Professional Manager
        if (
          this.myUser &&
          (this.myUser.userType == "professional" ||
            this.myUser.userType == "professionalManager")
        ) {
          this.aboutMeFormGroup.addControl(
            "company",
            new FormControl(this.myUser.company, Validators.required)
          );
        }

        // Professional Manager
        if (this.myUser && this.myUser.userType == "professionalManager") {
          this.aboutMeFormGroup.addControl(
            "professionalAddress",
            new FormControl(
              this.myUser.professionalAddress,
              Validators.required
            )
          );
          //this.securityFormGroup.addControl("professionalProfession", new FormControl(this.myUser.professionalProfession ? this.myUser.professionalProfession : ""));
        }

        // Different than Professional && Professioanl Manager
        if (
          this.myUser &&
          this.myUser.userType != "professional" &&
          this.myUser.userType != "professionalManager"
        ) {
          this.aboutMeFormGroup.addControl(
            "dateOfBirth",
            new FormControl(this.myUser.dateOfBirth)
          );
          this.aboutMeFormGroup.addControl(
            "phoneNumber",
            new FormControl(this.myUser.phoneNumber, Validators.required)
          );
          this.aboutMeFormGroup.addControl(
            "country",
            new FormControl(
              this.myUser.country ? this.myUser.country : "",
              Validators.required
            )
          );
        }

        // Different than Professional
        if (this.myUser && this.myUser.userType != "professional") {
          this.aboutMeFormGroup.addControl(
            "postCode",
            new FormControl(this.myUser.postCode, Validators.required)
          );
        }

        this.aboutMeFormGroup.addControl(
          "lastName",
          new FormControl(this.myUser.lastName, Validators.required)
        );
        this.aboutMeFormGroup.addControl(
          "firstName",
          new FormControl(this.myUser.firstName, Validators.required)
        );

        break;
      case "payment":
        this.paymentFormGroup = new FormGroup({});
        this.paymentFormGroup.addControl("Id", new FormControl(this.myUser.Id));
        this.paymentFormGroup.addControl(
          "ccHolder",
          new FormControl(this.myUser.ccHolder, Validators.required)
        );
        this.paymentFormGroup.addControl(
          "ccNumber",
          new FormControl(this.myUser.ccNumber, Validators.required)
        );
        this.paymentFormGroup.addControl(
          "ccExpire",
          new FormControl(this.myUser.ccExpire, Validators.required)
        );
        break;
      case "password":
        this.passwordFormGroup = new FormGroup({});

        this.passwordFormGroup.addControl(
          "Id",
          new FormControl(this.myUser.Id)
        );
        this.passwordFormGroup.addControl(
          "password",
          new FormControl("", [
            Validators.compose([
              Validators.required,
              // check whether the entered password has a number
              CustomValidators.patternValidator(/\d/, {
                hasNumber: true,
              }),
              // check whether the entered password has upper case letter
              CustomValidators.patternValidator(/[A-Z]/, {
                hasCapitalCase: true,
              }),
              // check whether the entered password has a lower case letter
              CustomValidators.patternValidator(/[a-z]/, {
                hasSmallCase: true,
              }),
              Validators.minLength(8),
            ]),
          ])
        );
        this.passwordFormGroup.addControl(
          "oldPassword",
          new FormControl("", Validators.required)
        );
        break;
      case "antiPhisingCode":
        this.antiPhishingCodeFormGroup = new FormGroup({});
        this.antiPhishingCodeFormGroup.addControl(
          "Id",
          new FormControl(this.myUser.Id)
        );
        this.antiPhishingCodeFormGroup.addControl(
          "createAntiPhishingCode",
          new FormControl(
            this.myUser.createAntiPhishingCode
              ? this.myUser.createAntiPhishingCode
              : ""
          )
        );
        break;
      case "planUpdates":
        this.planUpdateFormGroup = new FormGroup({});
        this.planUpdateFormGroup.addControl(
          "Id",
          new FormControl(this.myUser.Id)
        );
        // Different than Professional && Professioanl Manager
        if (
          (this.myUser && this.myUser.userType != "professional") ||
          (this.myUser && this.myUser.userType != "professionalManager")
        ) {
          this.planUpdateFormGroup.addControl(
            "planUpdateReminder",
            new FormControl(
              this.myUser.planUpdateReminder
                ? this.myUser.planUpdateReminder
                : ""
            )
          );
        }
        break;

      case "security":
        this.securityFormGroup = new FormGroup({});
        this.securityFormGroup.addControl(
          "Id",
          new FormControl(this.myUser.Id)
        );
        this.securityFormGroup.addControl(
          "mfaAlways",
          new FormControl(this.myUser.mfaAlways ? this.myUser.mfaAlways : "")
        );
        this.securityFormGroup.addControl(
          "mfaVia",
          new FormControl(this.myUser.mfaVia ? this.myUser.mfaVia : "")
        );
        break;

      case "itemOwners":
        this.itemOwnersFormGroup = new FormGroup({});

        this.itemOwnersFormGroup.addControl(
          "first",
          new FormControl(
            this.currentOwner.first ? this.currentOwner.first : false
          )
        );
        this.itemOwnersFormGroup.addControl(
          "last",
          new FormControl(
            this.currentOwner.last ? this.currentOwner.last : false
          )
        );
        this.itemOwnersFormGroup.addControl(
          "relationship",
          new FormControl(
            this.currentOwner.relationship ? this.currentOwner.relationship : false
          )
        );

        break;

      case "contactReferences":
        this.contactReferencesFormGroup = new FormGroup({});
        this.contactReferencesFormGroup.addControl(
          "Id",
          new FormControl(this.myUser.Id)
        );
        this.contactReferencesFormGroup.addControl(
          "offersAuthorization",
          new FormControl(
            this.myUser.offersAuthorization
              ? this.myUser.offersAuthorization
              : false
          )
        );
        // Different than Professional && Professioanl Manager
        if (
          (this.myUser && this.myUser.userType != "professional") ||
          (this.myUser && this.myUser.userType != "professionalManager")
        ) {
          this.contactReferencesFormGroup.addControl(
            "sendPlanUpdateReminders",
            new FormControl(
              this.myUser.sendPlanUpdateReminders
                ? this.myUser.sendPlanUpdateReminders
                : false
            )
          );
        }
        break;

      case "cancelZenplans":
    }
  }

  async saveAboutMe() {
    this.submitted = true;
    if (this.aboutMeFormGroup.invalid) {
      return;
    }
    this.aboutMeFormGroup.value["lastUpdate"] = new Date();
    this.aboutMeFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.aboutMeFormGroup.value);
    await this.zenplansDataService.updateUser(this.aboutMeFormGroup.value);
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  async savePayment() {
    this.paymentFormGroup.value["lastUpdate"] = new Date();
    this.paymentFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.paymentFormGroup.value);
    await this.zenplansDataService.updateUser(this.paymentFormGroup.value);
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  async savePassword() {
    this.submitted = true;
    if (this.passwordFormGroup.invalid) {
      this.isInvalid = true;
      return;
    }
    this.passwordFormGroup.value["lastUpdate"] = new Date();
    this.passwordFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.passwordFormGroup.value);
    await this.zenplansDataService.updateUser(this.passwordFormGroup.value);
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  async createAntiPhishingCode() {
    this.antiPhishingCodeFormGroup.value["lastUpdate"] = new Date();
    this.antiPhishingCodeFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.antiPhishingCodeFormGroup.value);
    await this.zenplansDataService.updateUser(
      this.antiPhishingCodeFormGroup.value
    );
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  async saveContactReferences() {
    this.contactReferencesFormGroup.value["lastUpdate"] = new Date();
    this.contactReferencesFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.contactReferencesFormGroup.value);
    await this.zenplansDataService.updateUser(
      this.contactReferencesFormGroup.value
    );
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  async savePlanUpdate() {
    let value = this.planUpdateFormGroup.value.planUpdateReminder;
    switch (value) {
      case "Every 3 Months":
        this.planUpdateFormGroup.value["planUpdateReminder"] = "90";
        break;
      case "Every 6 Months":
        this.planUpdateFormGroup.value["planUpdateReminder"] = "180";
        break;
      case "Once a Year":
        this.planUpdateFormGroup.value["planUpdateReminder"] = "365";
        break;
    }
    this.planUpdateFormGroup.value["lastUpdate"] = new Date();
    this.planUpdateFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.planUpdateFormGroup.value);
    await this.zenplansDataService.updateUser(this.planUpdateFormGroup.value);
    window.scrollTo(0, 0);
    this.ngOnInit();
    this.router.navigate(["/home"]);
  }

  async saveSecurity() {
    this.securityFormGroup.value["lastUpdate"] = new Date();
    this.securityFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.securityFormGroup.value);
    await this.zenplansDataService.updateUser(this.securityFormGroup.value);
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  showModalDeleteUser() {
    this.showModal = true;
  }

  async deleteUserAccount(choice) {
    if (choice === "Yes") {
      let data = await this.zenplansDataService.deleteUserAccount();
      if (data.success) {
        this.showModal = false;
        this.notificationService.changeMessage(
          new ZPNotification(
            "Request Accepted.",
            undefined,
            undefined,
            "You will be disconnected in a few seconds and your account will be deleted."
          )
        );
        setTimeout(() => {
          this.zenplansDataService.logout();
        }, 5000);
      }
    } else {
      this.showModal = false;
    }
  }

  updateIsClicked(val) {
    this.updateIsCheked = !val;
  }

  reminderIsClicked(val) {
    this.reminderIsCheked = !val;
  }

  openMobileMenu() {
    this.statusMobileMenu = !this.statusMobileMenu;
  }

  get f() {
    return this.aboutMeFormGroup.controls;
  }

  get g() {
    return this.passwordFormGroup.controls;
  }

  get h() {
    return this.itemOwnersFormGroup.controls;
  }

  async fileUpload(element) {
    this.dataIsLoaded = false;
    this.currentFile = await this.zenplansDataService.uploadFile(
      element.target.files[0],
      this.user.clientId,
      "logo"
    );
    let result = await this.zenplansDataService.uploadFile(
      element.target.files[0],
      this.user.clientId,
      "logo"
    );
    this.dataIsLoaded = true;
    if (result.success) {
      window.location.reload();
    } else {
      this.message = "Sorry, your file could not be uploaded.";
    }
  }

  callDialog(id, name) {
    this.itemToDeleteId = id;
    this.itemNameforDialog = name;
    this.showDialog = !this.showDialog;
  }
}

export interface IJointOwner {
  first: string;
  last: string;
  relationship: any;
}
